function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150,147.85A53.85,53.85,0,1,0,96.15,94,53.91,53.91,0,0,0,150,147.85Zm0-90.7A36.85,36.85,0,1,1,113.15,94,36.89,36.89,0,0,1,150,57.15Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M150,155.88a95,95,0,0,0-94.88,94.87c0,.21,0,.41,0,.64a8.5,8.5,0,0,0,8.5,8.46h0a8.51,8.51,0,0,0,8.46-8.54c0-.19,0-.37,0-.56a77.88,77.88,0,0,1,155.76,0c0,.18,0,.36,0,.55a8.5,8.5,0,0,0,8.46,8.53h0a8.51,8.51,0,0,0,8.5-8.47c0-.21,0-.41,0-.62A95,95,0,0,0,150,155.88Z"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.07c3e977.svg";
export { ForwardRef as ReactComponent };